// Snapping for a moving element (spec §6 "Precision"). PURE.
// An element's anchor snaps — per axis, to the NEAREST candidate within the threshold — to:
//   x: the tag centre x · another element's anchor x
//   y: the tag centre y · another element's anchor y · equal vertical spacing with two others
// Snapping only ever pulls TOWARD a candidate; outside the threshold the position is untouched.
export const SNAP_MM = 0.5;

// pos: { x, y } the un-snapped anchor · others: [{ x, y }] anchors of the other elements on the face
// centre: [cx, cy] of the body · threshold in mm
// → { x, y, guides: [{ axis: 'x' | 'y', at, kind: 'centre' | 'element' | 'spacing' }] }
//   axis 'x' = a VERTICAL guide line at x = at; axis 'y' = a horizontal one at y = at.
export function snapMove(pos, others, centre, threshold = SNAP_MM) {
  const xs = [{ at: centre[0], kind: 'centre' }, ...others.map(o => ({ at: o.x, kind: 'element' }))];
  const ys = [{ at: centre[1], kind: 'centre' }, ...others.map(o => ({ at: o.y, kind: 'element' }))];
  // equal vertical spacing: with neighbours a and b, the moving anchor may sit midway between them,
  // or continue their spacing above / below.
  for (let i = 0; i < others.length; i++) {
    for (let j = i + 1; j < others.length; j++) {
      const a = others[i].y, b = others[j].y;
      if (Math.abs(a - b) < 1e-9) continue;
      for (const at of [(a + b) / 2, 2 * a - b, 2 * b - a]) ys.push({ at, kind: 'spacing' });
    }
  }
  const nearest = (v, cands) => {
    let best = null;
    for (const c of cands) {
      const d = Math.abs(c.at - v);
      if (d <= threshold && (!best || d < best.d)) best = { ...c, d };
    }
    return best;
  };
  const sx = nearest(pos.x, xs), sy = nearest(pos.y, ys);
  const guides = [];
  if (sx) guides.push({ axis: 'x', at: sx.at, kind: sx.kind });
  if (sy) guides.push({ axis: 'y', at: sy.at, kind: sy.kind });
  return { x: sx ? sx.at : pos.x, y: sy ? sy.at : pos.y, guides };
}
